<template>
  <div class="login-page">
    <div class="login-card">
      <h2>触点 Z7 管理端</h2>
      <el-tabs v-model="activeTab" stretch>
        <el-tab-pane label="登录" name="login">
          <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" class="login-form">
            <el-form-item prop="username">
              <el-input v-model="loginForm.username" placeholder="请输入后台账号">
                <i slot="prefix" class="el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="请输入密码"
                show-password
              >
                <i slot="prefix" class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-button type="primary" :loading="loading" style="width: 100%" @click="submitLogin">
              登录
            </el-button>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="初始化注册" name="register">
          <el-alert
            title="仅当系统还没有任何管理员账号时可用。"
            type="warning"
            :closable="false"
            style="margin-bottom: 16px"
          />
          <el-form ref="registerFormRef" :model="registerForm" :rules="registerRules" class="login-form">
            <el-form-item prop="username">
              <el-input v-model="registerForm.username" placeholder="请输入后台账号">
                <i slot="prefix" class="el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="realName">
              <el-input v-model="registerForm.realName" placeholder="请输入姓名">
                <i slot="prefix" class="el-icon-user-solid"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="registerForm.mobile" placeholder="请输入手机号">
                <i slot="prefix" class="el-icon-phone"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="registerForm.email" placeholder="请输入邮箱">
                <i slot="prefix" class="el-icon-message"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="registerForm.password"
                type="password"
                placeholder="请输入密码"
                show-password
              >
                <i slot="prefix" class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <el-input
                v-model="registerForm.confirmPassword"
                type="password"
                placeholder="请再次输入密码"
                show-password
              >
                <i slot="prefix" class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-button type="primary" :loading="loading" style="width: 100%" @click="submitRegister">
              注册管理员
            </el-button>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { adminRegister } from '../../api/auth'
import { routes } from '../../router'
import { getDefaultAccessiblePath } from '../../utils/permissionRoute'

export default {
  name: 'LoginPage',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入确认密码'))
        return
      }
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'))
        return
      }
      callback()
    }

    return {
      activeTab: 'login',
      loading: false,
      loginForm: {
        username: '',
        password: ''
      },
      registerForm: {
        username: '',
        realName: '',
        mobile: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      registerRules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitLogin() {
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          await this.$store.dispatch('login', this.loginForm)
          const defaultPath = getDefaultAccessiblePath(routes, this.$store.getters.permissionCodes)
          this.$router.replace(defaultPath || '/')
        } catch (error) {
          // request.js already shows the user-facing error message.
        } finally {
          this.loading = false
        }
      })
    },
    submitRegister() {
      this.$refs.registerFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          await adminRegister(this.registerForm)
          Message.success('注册成功，请使用新账号登录')
          this.activeTab = 'login'
          this.loginForm.username = this.registerForm.username
          this.loginForm.password = this.registerForm.password
        } catch (error) {
          // request.js already shows the user-facing error message.
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #dbeafe, #f8fafc);
}

.login-card {
  width: 420px;
  background: #fff;
  padding: 36px;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(31, 45, 61, 0.12);
}

h2 {
  margin: 0 0 24px;
  color: #303133;
}

.login-form ::v-deep .el-input__prefix {
  left: 10px;
  color: #909399;
}

.login-form ::v-deep .el-input__inner {
  padding-left: 34px;
}
</style>
